import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ButtonComponent } from '../../core/buttons/button.component';
import { CheckboxComponent } from '../../core/controls/checkbox.component';
import { ActionRowComponent } from '../../core/panels/action-row.component';
import { DialogComponent } from '../../core/panels/dialog.component';

@Component({
  selector: 'app-confirm-dialog',
  imports: [
    ActionRowComponent,
    CheckboxComponent,
    CommonModule,
    DialogComponent,
    ButtonComponent,
    ReactiveFormsModule,
    RouterModule,
  ],
  template: ` <app-dialog #dialog [label]="label" [width]="width">
    <ng-template #content>
      <div class="tw-flex tw-items-center tw-gap-4 tw-pb-8">
        <div [innerHTML]="message"></div>
      </div>
      @if (showDoNotShowAgain) {
        <div class="tw-pt-4 tw-pb-8 tw--ml-2">
          <app-checkbox
            [control]="doNotShowAgain"
            label="Do not show this message again."
          />
        </div>
      }
      <app-action-row>
        <app-button (click)="confirmClick()" right1 [label]="yesLabel" />
        <app-button (click)="cancelClick()" emphasis="Low" right2 [label]="noLabel" />
      </app-action-row>
    </ng-template>
  </app-dialog>`,
  styles: [],
})
export class ConfirmDialogComponent {
  @ViewChild('dialog')
  dialog: DialogComponent;

  @Input()
  width = '35rem';

  /**
   * Typically question leading with "Are you sure..."
   */
  @Input()
  label = 'Confirmation';

  @Input()
  message = 'Are you sure?';

  @Input()
  showDoNotShowAgain = false;

  doNotShowAgain = new FormControl(false);

  @Output()
  confirm = new EventEmitter();

  @Output()
  cancel = new EventEmitter();

  @Input()
  yesLabel = 'Yes';

  @Input()
  noLabel = 'No';

  show() {
    this.dialog.visible = true;
  }

  close() {
    this.dialog.visible = false;
  }

  confirmClick() {
    this.confirm.emit();
    this.close();
  }

  cancelClick() {
    this.cancel.emit();
    this.close();
  }
}
